<template>
  <capture-list
    @downloadReport="downloadReport($event)"
    @loadData="loadData($event)"
    :loading-charge="capturesLoading"
    :captures="captures"
    :capturesLoading="capturesLoading"
    :selectedLanguage="selectedLanguage"
    :reportGenerating="reportGenerating"
    :totalCaptures="totalCount"
  ></capture-list>
</template>

<script>
import CaptureList from '../../components/CaptureList.vue';
import dayjs from '../../plugins/dayjs';
import { listCaptures } from '../../mixins/captures.mixins';
import { languageMethods, languageComputed } from '../../mixins/language.mixins';
import { csvReport } from '../../mixins/csvReport.mixins';
import { download } from '../../mixins/download.mixins';

export default {
  name: 'list-capture-view',
  components: { CaptureList },
  mixins: [
    csvReport,
    download,
    listCaptures,
    languageMethods,
    languageComputed,
  ],
  data: () => ({
    charge: null,
  }),
  computed: {
    totalCount() {
      return this.capturesListInfo.totalCount;
    },
  },
  methods: {
    async loadData({
      sort, page, maxPerPage, startDate, endDate, dateType, dynamicSearch,
    }) {
      this.capturesSearchObject = {
        page,
        maxPerPage,
        sort,
        startDate,
        dateType,
        endDate,
        dynamicSearch,
      };
      await this.listCaptures();
    },


    async downloadReport({ sort, startDate, endDate, dateType }) {
      const filename = `${this.$t(
        'pages.capture.list.filenamePrefix',
      )}-${dayjs().format('YYYY-MM-DD_HHmmss')}.csv`;
      this.reportCaptureGenerationObject = {
        filename,
        sort,
        startDate,
        dateType,
        endDate,
      };

      const result = await this.generateCaptureReport();

      if (!result.errorCode) {
        this.download({ data: this.reportData, filename });
      }
    },
  },
};
</script>
